<template>
  <nav class="navbar navbar-expand-md navbar-light bg-light fixed-top shadow-sm">
    <div class="container-fluid">
      <a class="navbar-brand fw-bold" href="/">
        <img class="logo" src="../assets/blackstar-logo.png">
      </a>

      <!-- Toggler -->
      <button class="navbar-toggler" type="button" @click="toggleFlyout">
        <i class="bi" :class="flyoutOpen ? 'bi-x-lg' : 'bi-list'"></i>
      </button>

      <!-- Flyout Menu (collapsible) -->
      <div class="offcanvas offcanvas-start" :class="{ 'show': flyoutOpen }" tabindex="-1" style="visibility: visible;"
        v-if="flyoutOpen">
        <div class="offcanvas-header">
          <h5 class="offcanvas-title">Menu</h5>
          <button type="button" class="btn-close" @click="toggleFlyout"></button>
        </div>
        <div class="offcanvas-body">
          <ul class="navbar-nav">
            <li class="nav-item"><a class="nav-link" href="/">Home</a></li>
            <li class="nav-item"><a class="nav-link" href="/about">About</a></li>
            <li class="nav-item"><a class="nav-link" href="/services/all-services">Services</a></li>
            <li class="nav-item"><a class="nav-link" href="/contact">Contact</a></li>
          </ul>
        </div>
      </div>

    <!-- Normal Links (desktop) -->
<div class="collapse navbar-collapse d-none d-md-block">
  <ul class="navbar-nav ms-auto">
    <li class="nav-item"><a class="nav-link" href="/">Home</a></li>
    <li class="nav-item"><a class="nav-link" href="/about">About</a></li>

    <li class="nav-item dropdown" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false" style="position: relative;">
      <a class="nav-link" href="/services/all-services">Services</a>
      <div v-show="showDropdown" class="dropdown-menu-custom">
        <a href="/services/point-of-sale" class="dropdown-item">Point of Sale</a>
        <a href="/services/card-terminals" class="dropdown-item">Card Terminals</a>
        <a href="/services/online-ordering" class="dropdown-item">Online Ordering</a>
        <a href="/services/all-services" class="dropdown-item">More Services</a>
      </div>
    </li>

    <li class="nav-item"><a class="nav-link" href="/contact">Contact</a></li>
  </ul>
</div>

    </div>
  </nav>
</template>

<script setup>
import { ref } from 'vue'
const flyoutOpen = ref(false)
const showDropdown = ref(false)

function toggleFlyout() {
  flyoutOpen.value = !flyoutOpen.value
}


</script>

<style scoped>
.offcanvas.show {
  visibility: visible !important;
  transform: none;
}

.logo {
  height: 30px;
}

.dropdown-menu-custom {
  position: fixed; /* Changed from absolute to fixed */
  left: 0;
  width: 100vw; /* Full viewport width */
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1050;
  padding: 0.5rem 1rem;
  border-radius: 0 0 8px 8px;
}


.dropdown-item {
  display: block;
  padding: 0.5rem 1rem;
  color: #212529;
  text-decoration: none;
  white-space: nowrap;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}
</style>
